import { render } from "./AboutView.vue?vue&type=template&id=48dedea6"
const script = {}

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.14_vue@3.5.14_typescript@5.8.3__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__